// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2WYUe","topBottomGutter":"Layout_topBottomGutter__17m1I"};